// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { ADVERTISEMENT_EXPENSES_REDUCER_KEY } from "..";
import { appStoreSalesMonths } from "../revenue/staticMonthsData";
import {
  ae_prOnOffInfluencerActivitiesMonths,
  same_marketingExpensesMonths,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "ae_";

// other revenue keys
export const ADVERTISEMENT_EXPENSES_INNER_TITLE_KEY =
  prefix + "advertisementExpensesInnerTitle";
export const ADVERTISEMENT_EXPENSES_KEY = prefix + "advertisementExpenses";
export const PR_INFLUENCER_ACTIVITIES_KEY =
  prefix + "prOnOffInfluencerActivities";

export const advertisementExpenseItems = [
  ADVERTISEMENT_EXPENSES_INNER_TITLE_KEY,
  ADVERTISEMENT_EXPENSES_KEY,
  PR_INFLUENCER_ACTIVITIES_KEY,
];

export const initialState = {
  [ADVERTISEMENT_EXPENSES_INNER_TITLE_KEY]: {
    title: "Advertisement Expenses",
    unit: unitType.INNER_TITLE,
    unitSymbol: getUnitSymbolByUnit(unitType.INNER_TITLE),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INNER_TITLE,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return "";
    },
    months: appStoreSalesMonths,
    years: {
      [years.YEAR_1_KEY]: "",
      [years.YEAR_2_KEY]: "",
      [years.YEAR_3_KEY]: "",
      [years.YEAR_4_KEY]: "",
      [years.YEAR_5_KEY]: "",
    },
  },
  [ADVERTISEMENT_EXPENSES_KEY]: {
    title: "Total",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      let result = 0;
      for (let i = 2; i < advertisementExpenseItems.length; i++) {
        result += Number(
          getReducerFunc(ADVERTISEMENT_EXPENSES_REDUCER_KEY)[
            advertisementExpenseItems[i]
          ]["years"][yearKey]
        );
      }
      return result;
    },
    months: same_marketingExpensesMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [PR_INFLUENCER_ACTIVITIES_KEY]: {
    title: "PR & ON/OFF Influencer Activities",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: ae_prOnOffInfluencerActivitiesMonths,
    years: {
      [years.YEAR_1_KEY]: 5000,
      [years.YEAR_2_KEY]: 5000,
      [years.YEAR_3_KEY]: 5000,
      [years.YEAR_4_KEY]: 5000,
      [years.YEAR_5_KEY]: 5000,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const advertisementExpensesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_ADVERTISEMENT_EXPENSE_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_ADVERTISEMENT_EXPENSE_BY_MONTHS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_ADVERTISEMENT_EXPENSE_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_ADVERTISEMENT_EXPENSE_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default advertisementExpensesReducer;
